import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RouteComponentProps, useHistory } from "react-router-dom";
import { addAPIError, removeAPIError, isUndefinedNullOrEmpty } from "../../utils/translation/helper";
import * as api from "../../api";
import {
  assetDataStatus,
  customersData,
  userChosenPropertyAddress,
  userChosenPropertyId,
  assetDataResponse,
  localAuthority,
  keyContact,
  userChosenBackValue,
  userChosenUPRN,
  assetPropertyId,
  customerPreferenceData,
  userChosenAlertValue,
  userChosenAssetHierarchy360,
  userChosenCovidQuestion,
  userChosenContactDetails,
  userChosenContactPhone,
  userChosenContactName,
  userChosenRelationDetails,
  userChosenAdditionalDescription,
  userChosenVandalismQuestion,
  userChosenVandalismAdditionalInformation,
  userChosenVulnerabilityQuestion,
  userChosenVulnerabilityAdditionalInformation,
  userChosenDuplicateQuestion,
  userChosenEmergencyQuestion,
  userChosenRepairLocationId,
  userChosenHighLevelDescription,
  userChosenRepairLocation,
  userChosenSupplementaryQuestions,
  userChosenSOR,
  userChosenSTATUS,
  userChosenEligibilityErrorCode,
  userChosenIsReporter,
  isActiveTenancy,
  userChosenIsRecall,
  loadDuplicateRepairPage,
  userChosenResumeRepair,
  userChosenDuplicateEntity,
  userChosenCurrentValue,
  backToCaseAsset,
  userChosenAssetValue,
  userChosentenancyGroup,
  caseAssetAddress,
  userChosenReporterId,
  userChosentenancyCount,
  caseCreatedBy,
  noUnit,
  customerAdditionalAlertData,
  clearMediaFiles,
  userChosenUploadedMediaIdentifiers, isCatalystProperty, userChosenIsSurvey, userChosenNotifyAll,
  selectedTenancyGroup,
  userChosenTenancyTypeDescription,
  premisesTypeList,
  dmcCheckSavedAnswer,
  backToRepairAsset,
  repairAddressData,
  setRepairDiagnosticFinalData,
  woFailureCase
} from "../../ducks/redux/actions/userChoices";
import { PermissionsList } from "../../models/Permissions";
import AssetDataResponse from "../../models/Property/AssetDataResponse";
import { addressToStringDetails, formatContent, isNullOrUndefined, getDeepLink, hasOverdueService} from "../../utils/formatting";
import AssetCardAsset360 from "../AssetCardAsset360";
import CustomerAssetCard from "../CustomerAssetCard";
import WorkSummaryCard from "../WorkSummaryCard";
import { trackEvent } from "../../appInsights/TelemetryService";

import {
  getCustomerId,
  saveCustomerDetails,
  saveCustomerphoneNumber,
  saveTenancySummaryList,
  selectedTenacyType,
  workOrderRepairObject,
  assetData,
  saveAssociatedAssests,
  getReferenceNumber,
  saveCustomerTenacies,
  getHeatingHotWaterCase,
  getMaintResp,
  getRepairResp,
  getContractorName,
  getDeterminedContractorDetails,
  getContractorPayload,
  saveSupplimentaryCodes,
  saveCurrentAssetEligibilityDetails,
  saveSubSessionAssetsEligibilityDetails
} from "../../ducks/redux/actions/getAddress";
import AsssetDetailCard from "../AssetDetailCard";
import KeyContactAssetCard from "../KeyContactAssetCard";
import { AlertValue, BackValue, CustomerOrProperty } from "../../models/shared/Enum";
import CustomerCardDetails from "../../models/Customer/CustomerCardDetail";
import CautionAlert from "../CautionAlert";
import PropertyAlert from "../PropertyAlert"
import CustomerResponseDetails from "../../models/Customer/CustomerResponseDetails";
import { userTypedRepairReasons, updateDashboardForm, assetByIdDataObject, priorityCode } from "../../ducks/redux/actions/dashboardReducer.actions";
import { Assets } from "../../models/Property/PropertyResponse";
import Preference from "../../models/Customer/Preference";
import { CASE_ASSET_CHECK, CASE_ASSET_TYPE, CASE_CUSTOMER_NAME, CASE_CUSTOMER_SEARCH, CASE_SELECTED_ANSWERS, CASE_TENANCY_ID, CASE_TENANCY_TYPE, CLEAR_CASE_STATE, CONTACT_INFORMATION_VALUE, EDIT_BUTTON_CLICK, ELIGIBLE_SELECT_CUSTOMER, USERCHOSEN_PROPERTY_ID } from "../../ducks/redux/actionTypes";
import TenancySummary from "../../models/Customer/TenancySummary";
import LoadingSpinner from "../../storybook/LoadingSpinner";
import CaseCard from "../Cases/CaseCard";
import AdditionalNeedAlert from "../AdditionalNeedAlert";
import openNewWindow from "../../assets/icons/Open-new-window-icon.png";
import { releaseAssetArrayDispatch, assetBackCouterDispatch, removeAssetArrayDispatch, assetArrayDispatch, getPreviousPageName, storeAPIErrors } from "../../ducks/redux/actions/FinancialReferral";
import BackToTopComponent from "../BackToTop";
import useBackToTop from "../BackToTop/useBackToTop";
import GasBoilerCard from "../GasBoilerCard";
import EICRCard from "../EICRCard";
import RedAlert from "../RedAlert";
import { getserviceCardData } from "../ServiceCard/serviceCard";
import { PremisesType, PremisesTypeId } from "../../models/Customer/Premises";
import { RelatedPremisesType } from "../../models/Property/AdminUnits";
import { checkPermissionAndSetState, hasPermission } from "../../utils/GetRoles/permission";
import { getAssetsById, getAssociatedAssets, getCustomerData, getEICR5YServiceCompliance, getGasBoilerServiceCompliance, getPropertyAssociates } from "../APIErrorComponent/APIConstantName";


interface Asset360ViewProps extends RouteComponentProps<any> { }
const Asset360View: React.FC<Asset360ViewProps> = (props) => {
  const isCheckForLandlord = process.env.REACT_APP_ISCHECKFORLANDLORD;
  const dispatch = useDispatch();
  const { backToTop, width } = useBackToTop();
  const [totalCount, setTotalCount] = useState(0);
  const array: AssetDataResponse[] = [];
  const [isLoading, setIsLoading] = useState(true);
  const [propertyList, setPropertyList] = useState(array);
  const [propertyAddress] = useState("");
  const [isWorkCard, setIsWorkCard] = useState(false);
  const [isAssetCard, setIsAssetCard] = useState(false);
  const [isCustomerCard, setIsCustomerCard] = useState(false);
  const [isRepair, setIsRepair] = useState(false);
  const [assetStatus, setAssetStatus] = useState("");
  const [isCustomerComponent, setIsCustomerComponent] = useState(false);
  let customerId: CustomerCardDetails[] = [];
  let tenancyData: TenancySummary[] = [];
  const EICRCardToggle = "isshowp360eicrcard";
  const GASCardToggle = "isshowp360gasboilercard";
  const [GASCardToggleValue, setGASCardToggleValue] = useState("false");
  const [EICRCardToggleValue, setEICRCardToggleValue] = useState("false");

  const [tenancyActiveList, setTenancyActiveList] = useState(tenancyData);
  const [customerIdList, setIsCustomerIdList] = useState(customerId);
  const [custId, setCustId] = useState("");
  const [isPropertyBanner, setIsProperty] = useState(false);
  const [preferenceCheck, setPreferenceCheck] = useState(false);
  const [propertyBannerCheck, setPropertyBannerCheck] = useState(false);
  const [assetType, setAssetType] = useState("");
  const [isCautionBanner, setIsCaution] = useState(false);
  const [isTenancyActiveFlag, setIsTenancyActive] = useState(false);
  const [isEligibleForSelectCustomer, setIsEligibleForSelectCustomer] = useState(false);
  const [errorFlag, setErrorFlag] = useState(false);
  const [identifiedCatalystProperty, setIsIdentifiedCatalystProperty] = useState(false);
  const [catalystBannerMessageA, setCatalystBannerMessageA] = useState("");
  const [catalystBannerMessageB, setCatalystBannerMessageB] = useState("");
  const [isCaseCard, setIsCaseCard] = useState(false);
  const [showVantage, setShowVantage] = useState(false);
  const [EICRserviceAlert, setEICRServiceAlert] = useState("");
  const [GASserviceAlert, setGASServiceAlert] = useState("");
  let [EICRPropsData, setEICRPropsData] = useState<any>();
  let [GASPropsData, setGASPropsData] = useState<any>();
  const [UCCReferenceData, setUCCReferenceData] = useState<any>([]);

  const errors = useSelector((state: any) => state.financialReferralReducer?.APIerrors);

  let assetRegionValue: string = "";
  const history = useHistory()

  enum LandlordAppConfigValues {
    IsCheckForLandlord = "IsCheckForLandlordP360",
    LandlordValues = "LandlordValues",
    CatalystRepairDisabledAreas = "CatalystRepairDisabledAreasP360",
    CatalystRegistrationAreas = "CatalystRegistrationAreas",
    isCataLystCaseCard = "isCataLystCaseCard"
  };

  enum AssetTypes {
    Property = "Property",
    Block = "Block",
    Estate = "Estate",
    DividedBlock = "Divided Block"
  };
  
  const finishJourney = useSelector((state: any) => state?.financialReferralReducer?.isJourneyFinish);
  const getPermissionsData = useSelector(
    (state: any) => state?.userChoicesReducer?.userProfilePermissions
  );
  const additionalNeedsAlertsBasic = hasPermission(getPermissionsData, PermissionsList.additional_needs_alerts_basic);
  const additionalNeedsAlertsRestricted = hasPermission(getPermissionsData, PermissionsList.additional_needs_alerts_restricted);
  const isCaseCheck = useSelector(
    (state: any) => state?.userChoicesReducer?.isCaseAllowed
  );
  const isP360Maintainence = useSelector(
    (state: any) => state.userChoicesReducer?.isP360RepairsMaintainenceValue
  );
  const [dropDown, setDropDown] = useState("none");
  const { t } = useTranslation();
  let counter = useSelector((state: any) => state?.financialReferralReducer?.assetBackCounter);
  const storeAssetData = useSelector((state: any) => state?.financialReferralReducer?.assetArrayData);
  const selectedTenancyGrp = useSelector((state: any) => state?.userChoicesReducer?.selectedTenancyGroup);
  let assetDataDetails = useSelector((state: any) => state?.addresses?.assetData);
  
  let subSessionAssetsEligibilityDetailsRedux = useSelector(
    (state: any) => state?.addresses?.subSessionAssetsEligibilityDetails
  );

  let tenancyGroup: string = "";


  const checkPremisesEligibility = async (
    premisesId: any,
    tenancyGroup: any,
    assetType: any,
    associatedAssetsData: any
  ) => {

    const currentAssetCachedEligibilityOutcome = subSessionAssetsEligibilityDetailsRedux?.find((assetEligDetailEle: any) => assetEligDetailEle.assetId == assetDataDetails?.id);
    if (isNullOrUndefined(currentAssetCachedEligibilityOutcome)) {
      const responsePremisesEligibilityResp = await api.postPremisesEligibility(
        premisesId,
        tenancyGroup
      );
      const assetTypeId = Number.parseInt(PremisesTypeId[assetType]);
      const hasParentPresent = associatedAssetsData?.filter((x: any) => {
        const associatedTypeId = Number.parseInt(PremisesTypeId[x.assetType]);
        return associatedTypeId < assetTypeId;
      });
      const hasParent = hasParentPresent?.length > 0;
      if (responsePremisesEligibilityResp?.length > 0) {

        const responsePremisesEligibility = responsePremisesEligibilityResp[0];
        // We want to stop scenario when asset maatches BR 12 & BR13 and is capable of skipping Repair Asset page
        const matchBR12BR13 = (responsePremisesEligibility?.errorCode === "E4" && assetType !== "Property") || responsePremisesEligibility?.errorCode === "E24";

        const assetEligibilityForRaiseRepair = {
          assetId: premisesId,
          assetEligibilityResponse: responsePremisesEligibility,

          // We want to stop scenario when asset matches BR 12 & BR13 and is capable of skipping Repair Asset page
          isEligibleToRaiseARepair: !( !responsePremisesEligibility?.isEligible && !hasParent && matchBR12BR13 )
        }
        let assetEligibilityDetailsCache = subSessionAssetsEligibilityDetailsRedux ?? [];
        assetEligibilityDetailsCache.push(assetEligibilityForRaiseRepair);
        dispatch(saveSubSessionAssetsEligibilityDetails(assetEligibilityDetailsCache));
        dispatch(saveCurrentAssetEligibilityDetails(assetEligibilityForRaiseRepair));
      }
    } else {
      dispatch(saveCurrentAssetEligibilityDetails(currentAssetCachedEligibilityOutcome));
    }

  }

  // Checking if back is clicked
  useEffect(() => {

    const viewAsset360View = Array.isArray(getPermissionsData) && getPermissionsData.includes(PermissionsList.view_asset_360_view);
    if (!viewAsset360View) {
      props.history.push("/LandingView");
    }
    if (storeAssetData?.length > 0) {
      assetDataDetails = storeAssetData[storeAssetData?.length - 1];
    }
  }, [storeAssetData, getPermissionsData]);

  const backButtonHandler = () => {
    if (storeAssetData === undefined || storeAssetData.length <= 1) {
      dispatch(assetPropertyId(""))
      dispatch(releaseAssetArrayDispatch(null))
      dispatch(assetBackCouterDispatch(0))

      if (finishJourney) {
        props.history.push("/LandingView")
      }
      else if (props.location.pathname === "/Asset360View") {
        history.push("/LandingView");
      }
      else { history.goBack() }

    } else {
      dispatch(assetBackCouterDispatch(counter - 1))
      dispatch(removeAssetArrayDispatch(storeAssetData[storeAssetData?.length]))
      globalThis.location.reload()
    }
  };


  let customerResponse: CustomerResponseDetails;
  let errorData: any = [];

  const clear = () => {
    dispatch(dmcCheckSavedAnswer(""));
    dispatch(userChosenIsSurvey(false));
    dispatch(userChosenNotifyAll(null));
    dispatch(userChosentenancyCount(0));
    dispatch(userChosenPropertyAddress(""));
    dispatch(userChosenRepairLocationId(0));
    dispatch(userChosenRepairLocation(""));
    dispatch(getReferenceNumber(null));
    dispatch(userTypedRepairReasons(""));
    dispatch(userChosenHighLevelDescription(""));
    dispatch(userChosenSupplementaryQuestions(""));
    dispatch(userChosenEmergencyQuestion(""));
    dispatch(userChosenDuplicateQuestion(""));
    dispatch(userChosenDuplicateEntity(""));
    dispatch(userChosenAdditionalDescription(""));
    dispatch(userChosenVandalismQuestion("No"));
    dispatch(userChosenVandalismAdditionalInformation(""));
    dispatch(userChosenCovidQuestion(""));
    dispatch(userChosenVulnerabilityQuestion(""));
    dispatch(userChosenVulnerabilityAdditionalInformation(""));
    dispatch(userChosenContactDetails(""));
    dispatch(userChosenUPRN(""));
    dispatch(userChosenPropertyId(""));
    dispatch(userChosenSOR(""));
    dispatch(getRepairResp(""));
    dispatch(getHeatingHotWaterCase(""));
    dispatch(getMaintResp(""));
    dispatch(userChosenSTATUS(""));
    dispatch(userChosenEligibilityErrorCode(""));
    dispatch(userChosenContactPhone(""));
    dispatch(userChosenContactName(""));
    dispatch(userChosenRelationDetails(""));
    dispatch(selectedTenacyType(""));
    dispatch(workOrderRepairObject(null));
    dispatch(getDeterminedContractorDetails(""));
    dispatch(getContractorName(""));
    dispatch(getContractorPayload(""));
    dispatch(userChosenIsReporter(false));
    dispatch(loadDuplicateRepairPage(false));
    dispatch(userChosenResumeRepair(false));
    dispatch({ type: CLEAR_CASE_STATE });
    dispatch({ type: CASE_SELECTED_ANSWERS });
    dispatch({ type: CASE_CUSTOMER_SEARCH });
    dispatch({ type: CASE_TENANCY_ID });
    dispatch({ type: CONTACT_INFORMATION_VALUE });
    dispatch({ type: CASE_TENANCY_TYPE });
    dispatch(saveCustomerphoneNumber(null));
    dispatch(caseAssetAddress(""));
    dispatch(userChosenRelationDetails(""));
    dispatch(userChosenReporterId(""));
    dispatch({ type: EDIT_BUTTON_CLICK, payload: false });
    dispatch(getCustomerId(""));
    dispatch({ type: CASE_CUSTOMER_SEARCH, payload: "" });
    dispatch(caseCreatedBy(""));
    dispatch({ type: CASE_CUSTOMER_NAME, payload: "" });
    dispatch({ type: CASE_ASSET_CHECK, payload: false });
    dispatch({ type: ELIGIBLE_SELECT_CUSTOMER, payload: false });
    dispatch(customerPreferenceData({}));
    dispatch(customerAdditionalAlertData({}));
    dispatch(clearMediaFiles([]));
    dispatch(userChosenUploadedMediaIdentifiers([]));
    dispatch(assetByIdDataObject(null));
    dispatch(selectedTenancyGroup(""));
    dispatch(saveSupplimentaryCodes(""));
    dispatch(userChosenAssetValue(null));
    dispatch(userChosenAssetHierarchy360(null));
    dispatch(saveAssociatedAssests(null));
    dispatch(userChosenBackValue(null));
    dispatch(userChosenCurrentValue(null));
    dispatch(priorityCode(""));
    dispatch(backToRepairAsset(false));
    dispatch(repairAddressData([]));
    dispatch(setRepairDiagnosticFinalData(null));
    dispatch(saveCurrentAssetEligibilityDetails(null));
  };
  const checkPermissionsForCards = () => {
    checkPermissionAndSetState(getPermissionsData, PermissionsList.view_asset_summary_card, setIsAssetCard);
    checkPermissionAndSetState(getPermissionsData, PermissionsList.view_customer_profile_card, setIsCustomerCard);
    checkPermissionAndSetState(getPermissionsData, PermissionsList.create_repair_standard, setIsRepair);
    checkPermissionAndSetState(getPermissionsData, PermissionsList.view_asset360_property_alerts_banner, setIsProperty);
    checkPermissionAndSetState(getPermissionsData, PermissionsList.view_open_crm, setShowVantage);
    checkPermissionAndSetState(getPermissionsData, PermissionsList.view_asset360_caution_alerts_banner, setIsCaution);

  }
  const fetchAssociatedAssets = async () => {
    try {
      const response = assetDataDetails?.id ? await api.getAssociatedAssets(assetDataDetails?.id) : null;
      errorData = removeAPIError(getAssociatedAssets, errors);
      return response;
    } catch (error: any) {
      console.error(error);
      errorData = addAPIError(getAssociatedAssets, errors);
      setIsWorkCard(true)
    }
    dispatch(storeAPIErrors(errorData))
  };

  const getAssetsListforLandlordCheck = async (associatedAssetsData: any) => {
    let assetList: AssetDataResponse[] = [];
    try {
      const associatedAssetsData: any = assetDataDetails?.id ? await fetchAssociatedAssets() : [];

      let associatedAssetData;
      if (assetDataDetails?.assetType === AssetTypes.Estate) {
        associatedAssetData = associatedAssetsData.filter(
          (x: any) => x.assetType === AssetTypes.Block || x.assetType === AssetTypes.Property
        );
      } else if ((assetDataDetails?.assetType === AssetTypes.Block)) {
        associatedAssetData = associatedAssetsData.filter(
          (x: any) =>
            x.assetType === AssetTypes.Property || x.assetType === AssetTypes.DividedBlock
        );
      } else if ((assetDataDetails?.assetType === AssetTypes.DividedBlock)) {
        associatedAssetData = associatedAssetsData.filter(
          (x: any) =>
            x.assetType === AssetTypes.Property
        );
      }
      else associatedAssetData = associatedAssetsData;
      if (associatedAssetData !== undefined) {
        associatedAssetData.forEach((element: any) => {
          const assetEntry: AssetDataResponse = new AssetDataResponse();
          assetEntry.id = element.id;
          assetEntry.address = addressToStringDetails(
            element?.addresses?.postalAddresses[0]
          );
          assetEntry.assetType = element.assetType;
          assetEntry.uprn = element.uprn;
          assetEntry.addresses = element?.addresses
          if (assetDataDetails.id !== assetEntry.id) {
            assetList.push(assetEntry);
          }
        });
      }
      return assetList;

    } catch (e) {
      console.error(e)
      setIsLoading(false)
    }
  }

  const getIsShowP360AssetComplianceDataToggle = async () => {
    try {
      const EICRCardToggleResponse = await api.GetAppConfigToggleValue(EICRCardToggle);
      const GASCardToggleResponse = await api.GetAppConfigToggleValue(GASCardToggle);

      if (EICRCardToggleResponse) {
        setEICRCardToggleValue(EICRCardToggleResponse.value);
      }

      if (GASCardToggleResponse) {
        setGASCardToggleValue(GASCardToggleResponse.value);
      }
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    // Adding a toggle to display/hide service card and alerts
    getIsShowP360AssetComplianceDataToggle()
    window.scrollTo(0, 0);
    setIsLoading(true)
    dispatch(saveAssociatedAssests(null));
    dispatch(userChosenIsRecall(false))
    dispatch(userChosenAssetHierarchy360(BackValue.Asset360View));
    (async () => {
      clear();
      checkPermissionsForCards();
      trackEvent("Asset360Page");

      if (isUndefinedNullOrEmpty(assetDataDetails)) {
        props.history.push("/LandingView");
        return;
      }

      dispatch(userChosenBackValue(BackValue.Asset360View));
      dispatch(userChosenCurrentValue(BackValue.Asset360View));
      let assetList: AssetDataResponse[] = [];


      dispatch(isActiveTenancy(false))
      setIsCustomerComponent(false)
      setPreferenceCheck(false);

      const associatedAssetsData: any = assetDataDetails?.id ? await fetchAssociatedAssets() : [];

      const premisesList: RelatedPremisesType[] = [];
      if (Array.isArray(associatedAssetsData)) {
        associatedAssetsData.forEach((element: any) => {
          const premisesEntry: RelatedPremisesType = new RelatedPremisesType();
          premisesEntry.premisesType = element.assetType as PremisesType;
          premisesEntry.premisesTypeId = element.id;
          premisesList.push(premisesEntry);
        });
      }
      dispatch(premisesTypeList(premisesList))
      callAlertApi(assetDataDetails?.id);
      customerCallApi(assetDataDetails?.uprn, assetDataDetails?.assetType, assetDataDetails?.id, associatedAssetsData);
      setAssetType(assetDataDetails?.assetType);
      dispatch(selectedTenacyType(assetDataDetails?.assetType));
      callGetAssetByIdApi(assetDataDetails?.id, associatedAssetsData);
      dispatch(
        userChosenPropertyAddress(
          addressToStringDetails(assetDataDetails?.addresses?.postalAddresses[0])
        )
      );
      try {
        if (assetDataDetails?.assetType !== "Property") {
          let i = 0;
          dispatch(noUnit(i));
          let associatedAssetData;
          if (assetDataDetails?.assetType === "Estate") {
            associatedAssetData = associatedAssetsData?.filter(
              (x: any) => x.assetType === "Block"
            );
          } else if ((assetDataDetails?.assetType === "Block")) {
            associatedAssetData = associatedAssetsData?.filter(
              (x: any) =>
                x.assetType === "Property" || x.assetType === "Divided Block"
            );
          } else if ((assetDataDetails?.assetType === "Divided Block")) {
            associatedAssetData = associatedAssetsData?.filter(
              (x: any) =>
                x.assetType === "Property"
            );
          }
          else associatedAssetData = associatedAssetsData;
          if (associatedAssetData !== undefined) {

            associatedAssetData.forEach((element: any) => {
              if (assetDataDetails?.assetType === "Block") {
                i = i + 1;
              }

              const assetEntry: AssetDataResponse = new AssetDataResponse();
              assetEntry.id = element.id;
              assetEntry.address = addressToStringDetails(
                element?.addresses?.postalAddresses[0]
              );
              assetEntry.assetType = element.assetType;
              assetEntry.uprn = element.uprn;
              assetEntry.addresses = element?.addresses
              if (assetDataDetails.id !== assetEntry.id) {
                assetList.push(assetEntry);
                setTotalCount(assetList?.length);
              }
            });
            dispatch(noUnit(i));
            setPropertyList(assetList);
          }
        }

      } catch (e) {
        console.log(e);
        setIsLoading(false)
      }
    })();
  }, []);

  const getGasBoilerData = async (assetId: string) => {
    const complianceType = t("GASService")
    const EICR = t("EICRService")
    try {
    const [res, res1] = await Promise.allSettled([
      getserviceCardData(assetId, EICR, false),
      getserviceCardData(assetId, complianceType, false)
    ]);
    const resValue = res.status === "fulfilled" ? res.value : undefined;
    const res1Value = res1.status === "fulfilled" ? res1.value : undefined;
    if (isNullOrUndefined(resValue[0])) {
      dispatch(storeAPIErrors(addAPIError(getEICR5YServiceCompliance, errors)));
    } else {
      dispatch(storeAPIErrors(removeAPIError(getEICR5YServiceCompliance, errors)));
    }
    if (isNullOrUndefined(res1Value)) {
      dispatch(storeAPIErrors(addAPIError(getGasBoilerServiceCompliance, errors)));
    } else {
      dispatch(storeAPIErrors(removeAPIError(getGasBoilerServiceCompliance, errors)));
    }
  
    if (resValue.length >0 ) {
      EICRPropsData = resValue;
      const EICRData = EICRPropsData?.filter((appliance: any) => appliance?.applianceType === 'EICREQUI');
      setEICRPropsData(EICRData);
    }
    
    if (res1Value.length >0 ) {
      GASPropsData = res1Value;
      const gasBoilerData = GASPropsData?.filter((appliance: any) => appliance?.applianceType === 'GASBOIL');
      setGASPropsData(gasBoilerData);
    }
    if (hasOverdueService(EICRPropsData?.[0]?.nextServiceDueDate)) {
      setEICRServiceAlert(`There is an Electrical service overdue for this property. Please contact ${EICRPropsData?.[0]?.contractor?.name || "-"} on ${EICRPropsData?.[0]?.contractor?.phoneNumber || "-"} to schedule a service visit.`);
    }
    if (hasOverdueService(GASPropsData?.[0]?.nextServiceDueDate)) {
      setGASServiceAlert(`There is a Gas boiler service overdue for this property. Please contact ${GASPropsData?.[0]?.contractor?.name || "-"} on ${GASPropsData?.[0]?.contractor?.phoneNumber || "-"} to schedule a service visit.`);
    }
  
  } catch (e: any) {
    console.log(e)
  }
}

  useEffect(() => {
    getGasBoilerData(assetDataDetails?.id)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetDataDetails?.id])

  const fetchGetPropertyAssociates = async (assetId: string) => {
    try {
      const data = await api.GetPropertyAssociates(assetId);
      errorData = removeAPIError(getPropertyAssociates, errors);
      return data;
    } catch (e) {
      errorData = addAPIError(getPropertyAssociates, errors);
      setIsLoading(false)
      console.error(e);
    }
    dispatch(storeAPIErrors(errorData))
  }
  
  const callGetAssetByIdApi = (id: string, associatedAssetsData: any) => {
    (async () => {
      try {

        if (id !== undefined && id !== null) {
          const assetResponse = await api.getAssetsByid(id);
          errorData = removeAPIError(getAssetsById, errors);
          dispatch(storeAPIErrors(errorData))
          setErrorFlag(false)
          dispatch(assetByIdDataObject(assetResponse));
          dispatch({ type: CASE_ASSET_TYPE, payload: assetResponse?.assetType });
          dispatch(assetDataResponse(assetResponse));
          dispatch(
            updateDashboardForm({
              assetId: assetResponse?.id
            })
          )
          dispatch(caseCreatedBy(assetResponse?.assetType));
          setAssetStatus(assetResponse?.assetStatus);
          assetRegionValue = assetResponse?.region;
          dispatch(assetDataStatus(assetResponse?.assetStatus));
          const data = await fetchGetPropertyAssociates(id);
          dispatch(userChosenAssetValue(assetResponse?.assetType));
          if (assetResponse.assetType === "Property") {
            const keyContactDetails = {
              regionalHousingManager:
                data.associates?.regionalHousingManager
                  ? data.associates.regionalHousingManager.person.name.givenName +
                    " " +
                    data.associates.regionalHousingManager.person.name.surname
                  : "",
              areaHousingManager:
                data.associates?.areaHousingManager
                  ? data.associates.areaHousingManager.person.name.givenName +
                    " " +
                    data.associates.areaHousingManager.person.name.surname
                  : "",
              assistantHeadOfNeighbourhoods:
                data.associates?.assistantHeadOfNeighbourhoods
                  ? data.associates.assistantHeadOfNeighbourhoods.person.name.givenName +
                    " " +
                    data.associates.assistantHeadOfNeighbourhoods.person.name.surname
                  : "",
              neighbourhoodManager:
                data.associates?.neighbourhoodManager
                  ? data.associates.neighbourhoodManager.person.name.givenName +
                    " " +
                    data.associates.neighbourhoodManager.person.name.surname
                  : "",
              lettingsOfficer:
                data.associates && data.associates.lettingsOfficer
                  ?
                  data.associates.lettingsOfficer.person.name.givenName +
                  " " +
                  data.associates.lettingsOfficer.person.name.surname
                  : "",
              incomesOfficer:
                data.associates && data.associates.incomesOfficer
                  ?
                  data.associates.incomesOfficer.person.name.givenName +
                  " " +
                  data.associates.incomesOfficer.person.name.surname
                  : "",
            };
            dispatch(keyContact(keyContactDetails));
          }

          checkIsCatalystProperty(assetRegionValue, assetDataDetails.assetType, assetDataDetails.id, associatedAssetsData)

          dispatch(localAuthority(data.associates.localAuthority.person.name.givenName));
        }
        else {
          console.error("Asset id is null");

        }
        setIsLoading(false)
      } catch (e) {
        errorData = addAPIError(getAssetsById, errors);
        dispatch(storeAPIErrors(errorData))
        setErrorFlag(true)
        setIsLoading(false)
        console.error(e);
      }
    })();
  };


  const showservicerequestcard = hasPermission(getPermissionsData, PermissionsList.view_case_summary_card);
  const createCaseStandard = hasPermission(getPermissionsData, PermissionsList.create_case_standard);

  const checkIsCatalystProperty = (assetRegionValue: string, assetDataDetailsAssetType: string, assetDataDetailsId: string, associatedAssetsData: any) => {
    (async () => {

      const appCatalystRegistrationAreasValues = await api.GetAppConfigToggleValue(
        LandlordAppConfigValues.CatalystRegistrationAreas
      );
      const appCatalystRepairDisabledAreasValues = await api.GetAppConfigToggleValue(
        LandlordAppConfigValues.CatalystRepairDisabledAreas
      );

      const isCatalystRegistrationAreas = !isUndefinedNullOrEmpty(assetRegionValue) && appCatalystRegistrationAreasValues.value.toLowerCase().includes(assetRegionValue.toLowerCase())
      const isCatalystDisabledArea = !isUndefinedNullOrEmpty(assetRegionValue) && appCatalystRepairDisabledAreasValues.value.toLowerCase().includes(assetRegionValue.toLowerCase());
      let isEnabledCatalystProperty = isCatalystRegistrationAreas && !isCatalystDisabledArea

      if (isCheckForLandlord === "true") {
        const isCataLystCaseCardValue = await api.GetAppConfigToggleValue(
          LandlordAppConfigValues.isCataLystCaseCard
        );
        const appConfigIsCheckForLandlord = await api.GetAppConfigToggleValue(
          LandlordAppConfigValues.IsCheckForLandlord
        );

        if (appConfigIsCheckForLandlord?.value === "true") {
          let propertyId: any;
          if (assetDataDetailsAssetType !== AssetTypes.Property) {
            let assetIdsforLandlordCheck = await getAssetsListforLandlordCheck(associatedAssetsData);
            if (assetIdsforLandlordCheck !== undefined) {
              for (let asset of assetIdsforLandlordCheck) {
                if (asset?.assetType === AssetTypes.Property) {
                  propertyId = asset?.id;
                  break;
                }
              }
              if (propertyId === undefined || propertyId === null) {
                propertyId = assetDataDetailsId;
              }
            }
          } else {
            propertyId = assetDataDetailsId;
          }


          const appConfigLandlordValues = await api.GetAppConfigToggleValue(
            LandlordAppConfigValues.LandlordValues
          );

          let appconfigLandlordValues = appConfigLandlordValues?.value;
          
          const associatesdata = await fetchGetPropertyAssociates(propertyId);

          let currentLandlord = associatesdata?.associates?.landLord?.organisation?.name;
          let previousLandLord = associatesdata?.associates?.previousLandLord?.organisation?.name;
          const landlordValuesExist = currentLandlord?.length > 0 || previousLandLord?.length > 0
          if (landlordValuesExist) {
            const isCatalystLandlord =
              currentLandlord?.length > 0 && appconfigLandlordValues.includes(currentLandlord) ||
              previousLandLord?.length > 0 && appconfigLandlordValues.includes(previousLandLord)
            const identifiedCatalystProperty = isCatalystRegistrationAreas || isCatalystLandlord

            isEnabledCatalystProperty = isCatalystLandlord && isEnabledCatalystProperty
            dispatch(isCatalystProperty(identifiedCatalystProperty))
            setIsWorkCard(!isCatalystRegistrationAreas || isEnabledCatalystProperty);
            setIsIdentifiedCatalystProperty(isCatalystRegistrationAreas);
            if (isCataLystCaseCardValue.value === "true") {
              setIsCaseCard(false);
            }
            else {
              setIsCaseCard(true);
            }
          }
          else {
            dispatch(isCatalystProperty(isCatalystRegistrationAreas))
          }
        }
        else {
          setIsWorkCard(true);
          dispatch(isCatalystProperty(isCatalystRegistrationAreas))
        }
      }
      else {
        setIsWorkCard(true);
        dispatch(isCatalystProperty(isCatalystRegistrationAreas))
      }

      switch (assetRegionValue) {
        case 'HUB1-REP':
          setCatalystBannerMessageA(t("CP126EnabledHub1a"));
          setCatalystBannerMessageB(t("CP126EnabledHubb"));
          break;
        case 'HUB2-REP':
          setCatalystBannerMessageA(t("CP126EnabledHub2a"));
          setCatalystBannerMessageB(t("CP126EnabledHubb"));
          break;
        case 'HUB3-REP':
          setCatalystBannerMessageA(t("CP126EnabledHub3a"));
          setCatalystBannerMessageB(t("CP126EnabledHubb"));
          break;
        case 'HUB4-REP':
          setCatalystBannerMessageA(t("CP126EnabledHub4a"));
          setCatalystBannerMessageB(t("CP126EnabledHubb"));
          break;
        default:
          // For Non Catalyst Properties, isIdentifiedCatalystProperty will be false, message wont be visible
          // For Catalyst properties where landlord is catalyst but fron a diff asset region
          setCatalystBannerMessageA(t("CP125a"));
          setCatalystBannerMessageB(t("CP125b"));
          break;
      }

      if (isCatalystDisabledArea) {
        setCatalystBannerMessageA(t("CP125a"));
        setCatalystBannerMessageB(t("CP125b"));
      }
    })();
  }

  const handleChangePropertyAddress = (e: { target: { value: any } }) => {
    setIsIdentifiedCatalystProperty(false)
    setCatalystBannerMessageA("");
    setCatalystBannerMessageB("");
    dispatch(isCatalystProperty(false))
    if (e.target.value !== "Select") {
      const propertySelectedData = propertyList.filter((x) => x.id === e.target.value);
      const assetEntry: Assets = new Assets();
      assetEntry.assetType = propertySelectedData[0].assetType
      assetEntry.uprn = propertySelectedData[0].uprn
      assetEntry.id = propertySelectedData[0].id
      assetEntry.addresses = propertySelectedData[0].addresses

      dispatch(assetArrayDispatch(assetEntry))
      dispatch(assetData(assetEntry))
      dispatch(caseCreatedBy(assetEntry?.assetType));
      dispatch(userChosenAssetValue(assetEntry.assetType));
      setTimeout(() => {
        // Give a few seconds for dispatch to setup, as we are reloading the same page
        globalThis.location.reload();
      }, 1000);
    }

  };

  const callAlertApi = (assetId: string) => {
    (async () => {
      try {
        const alertApiResponse = await api.getAlert(assetId);
        let finalAlertData: any[] = [];
        if (alertApiResponse) {
          alertApiResponse.map((alertData: any) => {
            if (alertData?.type === AlertValue.Rapid) {
              finalAlertData.push(alertData);
              setPropertyBannerCheck(true);
              dispatch(userChosenAlertValue(finalAlertData));
            }
          })
        }
        else {
          setPropertyBannerCheck(false);
        }

      } catch (e) {
        console.error(e);
        setIsLoading(false)
      }
    })()
  };
  const customerCallApi = (assetDataUPRN: string, assetType: string, assetId: string, associatedAssetsData: any) => {
    (async () => {
      try {
        setIsLoading(true)
        const queryParams = {
          searchText: "",
          skip: 0,
          customerType: "Active Customer",
          orderBy: "",
          tenancyType: "",
          uprn: assetDataUPRN,
        };

        const customerSearchApi = await api.getCustomerData(queryParams);
        let customerCallResponse = customerSearchApi?.models;
        errorData = removeAPIError(getCustomerData, errors)
        if (customerCallResponse.length > 2) {
          customerCallResponse = customerCallResponse.filter(
            customer =>
              customer.tenancyModels.some((tenency: any) => tenency.uprn === assetDataUPRN && tenency.isMainTenant)
          )
        }

          if (
            customerCallResponse[0]?.id !== undefined &&
            customerCallResponse[0]?.id !== ""
          ) {
            setCustId(customerCallResponse[0]?.id);
            dispatch(getCustomerId(customerCallResponse[0]?.id));
            let customerPreferenceDataObj: Preference[] = [];
            let custResponse: CustomerResponseDetails;

            if (assetType === "Property") {
              setIsCustomerComponent(true);
              setIsCustomerIdList(customerCallResponse);

              if (customerCallResponse[0].id !== undefined) {
                const tenancyResponse = await api.getTenanciesGroup(customerCallResponse[0].id, assetId);
                tenancyGroup = tenancyResponse[0]?.tenancyGroup;
              }
              dispatch(selectedTenancyGroup(tenancyGroup));
              dispatch(userChosentenancyGroup(tenancyGroup));

              customerCallResponse.forEach(async (element: CustomerCardDetails) => {
                if (element.id !== "" && element.id !== undefined && element.id !== null) {
                  try {
                    custResponse = await api.getCustomer(element.id);
                    if (customerCallResponse[0]?.id === element.id) {
                      customerResponse = custResponse;
                      const tenancyActive = customerResponse?.tenanciesSummaries.filter(
                        (ts) =>
                          ts.tenancySummary.statuses.find(
                            (s) => s.type === "isTenancyActive"
                          )?.value === true
                      );
                      dispatch(saveCustomerTenacies(tenancyActive));


                      if (tenancyActive?.length > 0) {
                        const tenancyActiveList = tenancyActive.filter(x => x.tenancySummary.premisesIds[0] === assetId);
                        dispatch(userChosentenancyCount(tenancyActiveList.length));
                        setTenancyActiveList(tenancyActiveList);
                        setIsTenancyActive(true);
                        dispatch(isActiveTenancy(true));

                        const tenancyType = tenancyActiveList?.[0]?.tenancySummary?.tenancyType;
                        let uccData = UCCReferenceData;

                        if (UCCReferenceData.length === 0) {
                          const response = await api.getUCCReferenceData();
                          uccData = Object?.values(response[0].namespace.keyValues);
                          setUCCReferenceData(uccData);
                        }

                        const filteredArrayTenancyType = uccData?.filter((el: any) => el.tenancyTypeID === tenancyType);
                        const tenancyTypeDescription = formatContent(filteredArrayTenancyType?.[0]?.tenancyType);
                        dispatch(userChosenTenancyTypeDescription(tenancyTypeDescription));
                        setTenancyActiveList(tenancyActiveList)
                        setIsTenancyActive(true);
                        dispatch(isActiveTenancy(true));
                      }

                      dispatch(saveCustomerphoneNumber(customerResponse?.addresses?.telecomsAddresses));
                      dispatch(saveCustomerDetails(customerResponse));
                      dispatch(customersData(customerResponse));
                      dispatch(saveTenancySummaryList(customerResponse?.tenanciesSummaries));
                      if (customerCallResponse?.length > 1) {
                        let activeTenancyCount = 0;
                        customerCallResponse.forEach((customer) => {
                          const activeTenant = customer.tenancyModels?.length > 0 ? customer.tenancyModels.filter(
                            (ts: any) => { return ts.isTenancyActive === true; }
                          ) : null;
                          if (activeTenant !== null && activeTenant !== undefined) {
                            activeTenancyCount++;
                          }
                        });
                        if (activeTenancyCount > 1) {
                          setIsEligibleForSelectCustomer(true);
                          dispatch({ type: ELIGIBLE_SELECT_CUSTOMER, payload: true })
                        }
                      }
                    }

                  }
                  catch (e) {
                    console.error(e);

                  }
                  if (custResponse?.preferences?.length > 0) {
                    customerPreferenceDataObj = customerPreferenceDataObj.concat(custResponse.preferences)
                    let customerAdditionalAlertDataObj: Preference[] = [];
                    let customerPreferenceAlertObj: Preference[] = [];
                    customerAdditionalAlertDataObj = customerPreferenceDataObj?.filter((additionalNeedAlert: any) => additionalNeedAlert.preference.type === 'additionalNeeds');
                    customerPreferenceAlertObj = customerPreferenceDataObj?.filter((additionalNeedAlert: any) => additionalNeedAlert.preference.type !== 'additionalNeeds');
                    if (customerPreferenceAlertObj.length > 0) {
                      setPreferenceCheck(true);
                      dispatch(customerPreferenceData(customerPreferenceAlertObj))
                    }
                    if (customerAdditionalAlertDataObj.length > 0) {
                      dispatch(customerAdditionalAlertData(customerAdditionalAlertDataObj))
                    }
                  }
                }
              });
            }
          }
        

        await checkPremisesEligibility(
          assetDataDetails?.id,
          tenancyGroup,
          assetDataDetails?.assetType,
          associatedAssetsData
        );
      } catch (e) {
        setIsLoading(false)
        console.error(e);
        setIsCustomerComponent(true)
        errorData = addAPIError(getCustomerData, errors)
      }
    })();
    dispatch(storeAPIErrors(errorData))
  };
  const dropDownFunction = () => {
    if (dropDown === "none") setDropDown("block");
    else setDropDown("none");
  };
  const callPageHandler = (assetType: string) => {
    if (!isP360Maintainence) {
      dispatch(getCustomerId(custId));
      dispatch(releaseAssetArrayDispatch(null));
      dispatch(getPreviousPageName(assetType));
      dispatch(priorityCode(''));
      dispatch(woFailureCase());
      props.history.push("/RepairAsset", { previousPathname: globalThis.location.pathname });
    }
  };
  const callVantageOnline = () => {
    const vatageURL = getDeepLink(CustomerOrProperty.Property, assetDataDetails?.addresses?.postalAddresses[0]?.id)
    window.open(vatageURL, '_blank')
  }
  const callCaseHandler = async () => {
    backToCaseAsset(false)
    if (assetDataDetails?.assetType === "Property" && isEligibleForSelectCustomer === true) {
      dispatch({ type: USERCHOSEN_PROPERTY_ID, payload: assetDataDetails.id });
      props.history.push("/SelectCustomer");
      //multiple customer
    }
    else {
      
      if (customerIdList?.length > 0 && assetDataDetails?.assetType === "Property") {
        let id = customerIdList[0].id
        if (id !== undefined) {
          tenancyGroup = selectedTenancyGrp;
        }
      }
      if (tenancyActiveList.length > 1) {
        props.history.push("/SelectTenancy");
      }
      else if ((tenancyActiveList.length === 1 || tenancyActiveList.length === 0) && assetDataDetails?.assetType === "Property") {
        props.history.push("/CaseType");
      }

      else if (assetDataDetails?.assetType !== "Property") {
        dispatch(userChosentenancyGroup("All"));
        props.history.push("/CaseType");
        //communal
      }

    }
  }
  const isRepairEnabled = assetType === "Property"
    ? isTenancyActiveFlag || (assetStatus === "OCCP" || assetStatus === "VOID")
    : true;

  const showworksOrderSurveys = hasPermission(getPermissionsData, PermissionsList.view_work_order_summary_card);
  if (isLoading) {
    return (
      <div className="div-loader">
        <div className="SpinnerWrapper">
          <LoadingSpinner />
        </div>
      </div>
    );
  }
  return (
    <div className="bg-no-repeat bg-right-60% bg-50% md:bg-35% lg:bg-20% bg-fixed px-4s">
      <div
        id="backmodal-div1"
        className="container mx-auto mb-0 md:mb-14 lg:mb-10 px-0 xl:px-0">
        <div id="backmodal-p" className="container mx-auto mb-0 md:mb-14 lg:mb-10 px-0 xl:px-0 global-txt flex space-between">
          <a
            data-testid="custBackBtn"
            className="back-btn mt-2"
            onClick={backButtonHandler}
          >
            <i className="fas fa-angle-left mr-2"></i>
            {t("back")}
          </a>
          {isRepairEnabled && isRepair && (<div className="menu-nav ms-auto bd-highlight float-right">
            <div className="dropdown-container-h btn-group dropdownNegativeMargin mt-2">
              <div
                data-testid="dotsmenu"
                className=" kebabBtn btn-sm mr-1 three-dots-ast mt-2 btn"
                data-bs-toggle="dropdown"
                onClick={dropDownFunction}
              ></div>
              <div
                className="dropdown-ast px-2 dropdown-menu mt-45"
                style={{ display: dropDown }}
              >{//Logic for showing Raire Repair/Raise Communal repair Option in Kebab menu
                  isRepairEnabled ? (
                    <a
                      data-testid="callpage"
                      className="text-black no-underline dropdown-item global-txt"
                      onClick={(e: any) => callPageHandler(assetType)}
                    >
                      <div className={"cursor-pointer text-base dropdown-item pl-0 " + (isP360Maintainence ? 'text-opacity-25 pe-none' : '')}>
                        {t("Create_repair")}
                      </div>
                    </a>) : ((assetType === "Divided Block" || assetType === "Block" || assetType === "Estate") ?
                      (<a
                        data-testid="callpage"
                        className="text-black no-underline dropdown-item  global-txt"
                        onClick={(e: any) => callPageHandler(assetType)}
                      >
                        <div className={"cursor-pointer text-base dropdown-item pl-0 " + (isP360Maintainence ? 'text-opacity-25 pe-none' : '')}>
                          {t("raise_comm")}
                        </div>
                      </a>) : null)
                }
                {createCaseStandard && (isCaseCheck === 'true' && ((assetType === "Property" && (assetStatus === 'OCCP' || assetStatus === 'VOID')) || (assetType === 'Block' || assetType === 'Divided Block' || assetType === 'Estate'))) ?
                  <a data-testid="casepage" onClick={callCaseHandler} className="text-black text-base no-underline global-txt">
                    <div className="py-2 cursor-pointer text-base dropdown-item">
                      {t("CP104")}

                    </div>
                  </a> : null}

                {showVantage ? (
                  <a data-testid="vantagepage" onKeyDown={callVantageOnline} onClick={callVantageOnline} className="text-black text-base no-underline global-txt">
                    <div className="py-2 cursor-pointer text-black text-base no-underline dropdown-item">
                      {t("open_vantage")}
                      <span className="float-right pt-1"><img
                        src={openNewWindow}
                        alt=""
                        className="h-4 w-4 my-0 text-lg text-teal"
                      ></img></span>

                    </div></a>
                ) : null}
              </div>
            </div>
          </div>)}
        </div>
      </div>
      <div className="container mx-auto global-txt">
        <div className="w-full lg:px-0">
          {/* <div className="border-b border-grey py-2"> */}
          <div className="flex flex-row d-flex bd-highlight">
            <div className="bd-highlight ">
              <h1 className="mpx-4 mt-4">
                {propertyAddress !== ""
                  ? propertyAddress
                  : addressToStringDetails(
                    assetDataDetails?.addresses?.postalAddresses[0]
                  )}
              </h1>
            </div>
          </div>
          {totalCount > 0 ? (
            <div>
              {assetDataDetails.assetType === "Divided Block"
                ? t("DividedBlock")
                : assetDataDetails.assetType === "Block"
                  ? t("Block")
                  : assetDataDetails.assetType === "Estate"
                    ? t("Estate")
                    : null}{" "}
              <br />
              <label className="w-full">
                <select
                  className="block w-full mt-1 rounded-lg border border-grey sm-mr-1 bg-grey mb-1"
                  data-testid="propertyChangeDropDown" id="propertyDropDown"
                  onChange={handleChangePropertyAddress}
                  value={""}
                >
                  <option>Select</option>
                  {propertyList.map((property) => (
                    <option key={property.id} value={property.id}>
                      {property.address}
                    </option>
                  ))}
                </select>
              </label>
            </div>
          ) : null}
          {/* </div> */}
        </div>

        {identifiedCatalystProperty ? (
          <div className="warning-pre-line alert p-0 mb-8">
            <div className="w-full px-2 py-2 bg-purple-20 flex items-center">
              <div className="px-4 pr-8">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" className="text-purple-100 w-6 h-6">
                  <path d="M480 179.6C498.6 188.4 512 212.1 512 240C512 267.9 498.6 291.6 480 300.4V448C480 460.9 472.2 472.6 460.2 477.6C448.3 482.5 434.5 479.8 425.4 470.6L381.7 426.1C333.7 378.1 268.6 352 200.7 352H192V480C192 497.7 177.7 512 160 512H96C78.33 512 64 497.7 64 480V352C28.65 352 0 323.3 0 288V192C0 156.7 28.65 128 64 128H200.7C268.6 128 333.7 101 381.7 53.02L425.4 9.373C434.5 .2215 448.3-2.516 460.2 2.437C472.2 7.39 480 19.06 480 32V179.6zM200.7 192H192V288H200.7C280.5 288 357.2 317.8 416 371.3V108.7C357.2 162.2 280.5 192 200.7 192V192z"></path></svg>
              </div>
              <div className="flex items-center">
                <p className="w-full text-left my-2 font-AvantGardeGothic-Md">
                  <div>{catalystBannerMessageA}</div><br /><div>{catalystBannerMessageB}</div></p>
              </div>
            </div>
          </div>
        ) : null}

        {/* adding service alert here */}
        {EICRserviceAlert && EICRCardToggleValue === "true" && (
          <RedAlert alertType={""} Alert={EICRserviceAlert} {...props} />
        )}
        {GASserviceAlert && GASCardToggleValue === "true" && (
          <RedAlert alertType={""} Alert={GASserviceAlert} {...props} />
        )}
        {/* end service alert */}

        {preferenceCheck && isCautionBanner ? (
          <div className="pb-2">
            <CautionAlert {...props} />
          </div>
        ) : null}
        {/* Assets view */}
        {(additionalNeedsAlertsBasic || additionalNeedsAlertsRestricted) ?
          (<div className="pb-2">
            <AdditionalNeedAlert {...props} />
          </div>) : null
        }
        {isPropertyBanner && propertyBannerCheck ? (
          <div className="pb-2">
            <PropertyAlert  {...props} />
          </div>
        ) : null
        }

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 mb-30">

          <div className=""><AsssetDetailCard errorFlag={errorFlag}  {...props} />
          </div>

          {isWorkCard && showworksOrderSurveys ? (
            <div className="">
              <div className=" relative border pb-16 border-grey bg-white rounded-lg cust-card">
                <WorkSummaryCard {...props} />
              </div>
            </div>
          ) : null}


          {isCustomerComponent ? (
            isCustomerCard ? (
              <div className="">
                <CustomerAssetCard
                  customerAssetList={customerIdList}
                  {...props} />
              </div>
            ) : null
          ) : null}

          {isAssetCard ? (
            <div className="cust-card m-0 display-column">
              <div className="relative pb-16 border border-grey bg-white display-column  rounded-lg cust-card">
                <AssetCardAsset360 errorFlag={errorFlag} {...props} />
              </div>
            </div>
          ) : null}


          {showservicerequestcard && isCaseCard === false && isCaseCheck === 'true' ? (
            <div className="" data-testid="caseCard">
              <CaseCard errorFlag={errorFlag} {...props} />
            </div>
          ) : null}

          {assetDataDetails?.assetType === "Property" &&
            <div className=""><KeyContactAssetCard {...props} />
            </div>}

          {/* Adding EICR and Gas boiler Card here */}
          {EICRCardToggleValue === "true" && EICRPropsData && <div className="">
            <EICRCard EICRPropsData={EICRPropsData}{...props} />
          </div>}
          {GASCardToggleValue === "true" && GASPropsData && <div className="">
            <GasBoilerCard GASPropsData={GASPropsData}{...props} />
          </div>}
          {/* end both card */}
        </div>
        <div className="mb-8 px-2">
          {(backToTop && width <= 820) && <BackToTopComponent />}
        </div>

      </div>
    </div>
  );
};
export default Asset360View;